import SearchIcon from '../assets/icons/search.svg?react';
import { cn } from '../utils/className';
import { Input } from './Input';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  'aria-label'?: string;
  className?: string;
}

/** A text input with a leading magnifier, dimmed until it holds a term. */
export function SearchInput({
  value,
  onChange,
  placeholder,
  'aria-label': ariaLabel,
  className,
}: SearchInputProps) {
  return (
    <div className={cn('relative w-full min-w-0', className)}>
      <span
        className='text-disabled pointer-events-none absolute top-1/2 left-2
          flex h-4 w-4 -translate-y-1/2 items-center justify-center
          [&_path]:fill-current [&_svg]:fill-current'
      >
        <SearchIcon />
      </span>
      <Input
        type='text'
        placeholder={placeholder || 'Search...'}
        aria-label={ariaLabel}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant={value.length > 0 ? 'default' : 'inactive'}
        className='w-full pl-8'
      />
    </div>
  );
}
